<div class="out"  kzLib (click)="schedule($event)" [ngClass]="{blue:bShowOptions}">
  <div class="conent">
    <div class="tx">Schedule Call
      <!-- <img class="expand" src="assets/images/exp10.svg" [ngClass]="{flip:bShowOptions}"> -->
    </div>
  </div>

</div>
